<div class="fm-dashboard-page">

  @if (isLoading()) {
    <div class="fm-page-loader">
      <div class="spinner-border fm-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  } @else {

    <!-- Page Title -->
    <div class="row g-0 align-items-center mb-3 mb-xl-4">
      <div class="col">
        <h4 class="fm-admin-title mb-0">Dashboard</h4>
      </div>
    </div>

    <!-- Welcome Banner -->
    <div class="fm-welcome-banner mb-3 mb-xl-4">
      <div class="fm-welcome-banner-inner">
        <h5 class="fm-welcome-title mb-1">Welcome back, {{ profile()?.fullName ?? 'there' }}! 👋</h5>
        <p class="mb-0 fm-welcome-sub">Here's what's happening in your family space today.</p>
      </div>
    </div>

    <!-- Stats Cards -->
    @if (stats()) {
      <div class="row g-3 g-xl-4 mb-3 mb-xl-4">
        <div class="col-12 col-sm-4">
          <div class="fm-stat-card">
            <div class="fm-stat-icon fm-stat-icon--total">
              <img src="images/icons/dashboard-icons/stories.svg" alt="" />
            </div>
            <div class="fm-stat-body">
              <p class="fm-stat-value mb-0">{{ stats()!.totalCampaigns }}</p>
              <p class="fm-stat-label mb-0">Total Campaigns</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="fm-stat-card">
            <div class="fm-stat-icon fm-stat-icon--active">
              <img src="images/icons/dashboard-icons/story-book.svg" alt="" />
            </div>
            <div class="fm-stat-body">
              <p class="fm-stat-value mb-0">{{ stats()!.activeCampaigns }}</p>
              <p class="fm-stat-label mb-0">Active Campaigns</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="fm-stat-card">
            <div class="fm-stat-icon fm-stat-icon--done">
              <img src="images/icons/fm-check.svg" alt="" />
            </div>
            <div class="fm-stat-body">
              <p class="fm-stat-value mb-0">{{ stats()!.completedCampaigns }}</p>
              <p class="fm-stat-label mb-0">Completed</p>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Recent Activity -->
    <div class="fm-section-card">
      <div class="fm-section-card-head">
        <h5 class="fm-section-title mb-0">Recent Activity</h5>
      </div>
      <div class="fm-section-card-body">
        @if (recentActivity().length === 0) {
          <div class="fm-empty-state">
            <img src="images/icons/fm-heart-cl.svg" alt="" class="fm-empty-icon" />
            <p class="mb-0">No recent activity yet. Start creating your family stories!</p>
          </div>
        } @else {
          <div class="fm-activity-list">
            @for (item of recentActivity(); track item.id) {
              <div class="fm-activity-item">
                <div class="fm-activity-info">
                  <p class="fm-activity-title mb-0">{{ item.title }}</p>
                  <p class="fm-activity-desc mb-0">{{ item.description }}</p>
                </div>
                <span class="fm-activity-date">{{ item.date }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>

  }
</div>
